// Popisky doplňkového menu topbaru (topBarLinks.js).
export default {
  blog: 'Blog',
  b2b: 'Velkoobchod',
  service: 'Servis nářadí',
  store: 'Prodejna nářadí',
  shipping: 'Doprava a platba',
  contact: 'Kontakt',
  orderStatus: 'Stav objednávky',
  /** aria-label celé řady */
  nav: 'Informace',
};
